export default __webpack_public_path__ + "static/media/Neutrif-Studio-Medium.cb816708.ttf";